// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 11 13" {...rest} unit={unit}>
		<g transform="translate(-25.000000, -24.000000)" fill="#0B1C17">
			<polygon id="T" points="35.9017857 24 35.9017857 26.7142857 32.0982143
			26.7142857 32.0982143 37 28.7321429 37 28.7321429 26.7142857
			25 26.7142857 25 24" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/T.js